import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DDLDataTable } from "../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import FileSaver from "file-saver";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { IROEWeb } from "../../models/ROEWeb";
import { Message } from "@mui/icons-material";
import { ROEService } from "../../services/ROEService";
import { ROESetupToolbar } from "../ROESetup/ROESetupToolbar";
import { ROESetupValidationSchema } from "../ROESetup/validator";
import { ROEWebDataTable } from "./ROEWebDataTable";
import { ROEWebInfoFieldsPanel } from "./Panels/ROEWebInfoFieldsPanel";
import { ROEWebToolbar } from "./ROEWebToolbar";
import { ROEWebValidationSchema } from "./validator";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";









export interface IROEWebSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "roe-web-single-data-record";
const ROE_WEB_DDL_DATA_QUERY_KEY = "roe-ddl-list";

const useGetData = (
	clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, clientId, id, navigateToLogout],
		queryFn: () => {
			return ROEService.getById(clientId, id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useROE = (
	clientId: string,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [ROE_WEB_DDL_DATA_QUERY_KEY],
		queryFn: (data) => {

			return ROEService.getROEWebDDLData(
				clientId,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

export const ROEWeb: React.FC<IROEWebSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [roeWebId, setRoeWebId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState<any>(false);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState<any>(id);

	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useROE(
		clientId,
		navigateToLogout
	);

	const roeWebList: any | null = data;

	const { isPending: isSubmitting, mutate: submitROEWebFormFields } =
		useMutation({
			mutationFn: ROEService.createROEWebXml,
			// mutationFn: ROEService.createROEWebXml,
			onSuccess: (res: any | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIROEWebResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/compliance/roe/web/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [ROE_WEB_DDL_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIROEWebResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/compliance/roe/web/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [ROE_WEB_DDL_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		clientId,
		editRecordId,
		navigateToLogout
	);


	const upadtedROEListItems = useMemo(() => {
		return (
			roeWebList &&
			roeWebList &&
			sortDDLByLabel(roeWebList)?.map((item: any) => ({
				...item,
				label: (
					<span
					// to={`/compliance/roe/web`}
					// className="no-underline"
					// style={{ color: theme.palette.primary.light }}
					// onClick={() => setEditRecordId(item.value)}
					>
						{item.label}
					</span>
				),
			}))
		);
	}, [roeWebList]);


	const DEFAULT_VALUES = {
		fileName: undefined,
		type: undefined,
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(ROEWebValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {
		if (selectedRowsValues && selectedRowsValues.length === 0) {
			setSnackbarData({
				open: true,
				message: "Please Select Employee",
				severity: "error"
			})
		}
		else {
			let payload = {
				clientId: clientId,
				// id: id && id,
				fileName: values.fileName,
				webProcessingMethod: values.webProcessingMethod,
				// roeIds: selectedRowsValues
				roeIds: selectedRowsValues.map((row: any) => row.value),
			};
			submitROEWebFormFields(payload);
		}
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteROEById } = useMutation({
		mutationFn: ROEService.delROE,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the ROE fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/compliance/roe/web`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [ROE_WEB_DDL_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteROEField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				roeWebId: roeWebId,
				navigateToLogout: navigateToLogout,
			};
			deleteROEById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setRoeWebId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setRoeWebId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveROEById } = useMutation({
		// mutationFn: ROEService.archiveROE,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the ROE fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/compliance/roe/web`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [ROE_WEB_DDL_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	// const archiveROEField = () => {
	// 	if (singleArchive) {
	// 		setSingleArchive(false);
	// 		let ArchivePayload = {
	// 			roeWebId: roeWebId,
	// 			navigateToLogout: navigateToLogout,
	// 		};
	// 		archiveROEById(ArchivePayload);
	// 		setArchiveDialogOpen(false);
	// 	}
	// };

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setRoeWebId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/compliance/roe/web`;
		navigate(path);
	};

	const expandedLabels = ["Compliance", "ROE"];
	const expandedROESetupOrSetupItem = "Web"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "ROE" &&
				item.label === expandedROESetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedROESetupOrSetupItem && "/compliance/roe/web",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		roeWebName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IROEWeb | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/compliance/roe/web/${params.value}`;
		navigate(path);
	}, []);

	const onMarkAsSubmittedClicked = async (): Promise<void> => {
		setIsLoading(true);
		try {
			const roeIds = selectedRowsValues.map((row: any) => row.value);

			if (roeIds.length === 0) {
				setSnackbarData({
					open: true,
					message: "Please select employee.",
					severity: "error",
				});
				setIsLoading(false);
				return
			}
			const response: any = await ROEService.updatedROEWebMarkAsSubmitted(roeIds);
			await queryClient.invalidateQueries({
				queryKey: [ROE_WEB_DDL_DATA_QUERY_KEY],
			});

			if (response) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			}
			if (response.status === 400) {
				setSnackbarData({
					open: true,
					message: response.data?.message ?? "Something went wrong.",
					severity: "error",
				});
			}
		} catch (err) {
			alert(err);
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"ROE Web"}
			</div>

			<Grid
			// sx={{
			// 	pb: "5rem",
			// 	"& .MuiAppBar-root": {
			// 		zIndex: 2,
			// 		top: subMenuVisibility ? "154px" : "112px",
			// 	},
			// }}
			>
				<BackdropCircularProgress
					open={isSubmitting || isPendingById || isDeleting || isArchive || isLoading}
					testId="roe Web"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteROEField}
					cancelActionHandler={onCloseHandler}
					testId="roeWeb-confirmation-dialog"
				/>
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>
						<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<Grid size={{ xs: 12, sm: 12, md: 3.3, lg: 3.3, xl: 3.3 }}>
								<SingleColumnLayout
									children={
										<StandardPanel
											title="ROE"
											testId={`roeWeb`}
											// leftSpacing={1}
											// rightSpacing={1}
											showTitle={false}
											variant="outlined"
											topPadding={2}
										>
											<ROEWebInfoFieldsPanel />
										</StandardPanel>
									}
									toolbar={[]
										// <ROEWebToolbar
										// 	onResetClicked={onResetClicked}
										// 	onDeleteClicked={onDeleteClicked}
										// 	isSubmitting={false}
										// 	id={id}
										// />
									}
									showFullDiaplay={true}
									toolbarPosition="bottom"
									testId="form-layout"
								/>
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 5, lg: 5, xl: 5 }}></Grid>
							<Grid
								size={{ xs: 12, sm: 12, md: 3.7, lg: 3.7, xl: 3.7 }}
								sx={{ marginTop: "16px" }}
							>
								<ROEWebDataTable
									// columns={
									// 	roeWebList && roeWebList
									// 		// ? roeWebList.headerColumns.filter(
									// 		// 	(item: any) => item.field !== "id"
									// 		// )
									// 		// : []
									// }
									columns={[
										{ field: "label", headerName: "Label" },
									]}
									rows={
										roeWebList && upadtedROEListItems
											? upadtedROEListItems
											: []
										// roeWebList?.items ?? []
									}
									onRowEditClicked={onRowEditClicked}
									onRowDeleteClicked={onRowDeleteClicked}
									onRowArchiveClicked={onArchiveClicked}
									isLoading={isPending}
									totalRecords={
										roeWebList && roeWebList.total
											? roeWebList.total
											: 0
									}

									selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
									showArchiveIcon={false}
									showDeleteIcon={false}
									showChecboxColumn={true}
									showPaginator={false}
									// initialPageSize={INITIAL_PAGE_SIZE}
									// rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
									onRequestParamsChange={onRequestParamsChange}
									tableScrollHeight={"60vh"}

								/>
								<ROEWebToolbar
									// onGenerateROEXMLClicked={onGenerateROEXMLClicked}
									onMarkAsSubmittedClicked={onMarkAsSubmittedClicked}
									onDeleteClicked={onDeleteClicked}
									isSubmitting={false}
									id={id}
								/>
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
						</Grid>
					</form>
				</FormProvider>

				{/* Archive Dialogue */}
				<EnhancedDialog
					dialogTitle="Please Confirm"
					key="dialog-box"
					testId="dialog"
					onCloseHandler={onCloseArchiveHandler}
					open={openArchiveDialog}
					dialogContent={null}
					showdividers={false}
					dialogAction={
						<Grid>
							<EnhancedButtonPrimeReact
								label="Cancel"
								severity="secondary"
								text
								raised
								onClickHandler={onCloseArchiveHandler}
								style={{ fontSize: "small" }}
							/>
							<EnhancedButtonPrimeReact
								label="Archive"
								severity="secondary"
								raised
								// onClickHandler={() => archiveROEField}
								style={{ marginLeft: "16px", fontSize: "small" }}
							/>
						</Grid>
					}
				/>

				<EnhancedSnackbar
					message={snackbarData.message}
					onCloseHandler={onSnackbarClosed}
					severity={snackbarData.severity}
					testId={"roeWeb-snackbar"}
					open={snackbarData.open}
				/>
			</Grid>
		</>
	);
};
